import { useTheme, Box } from "@mui/material";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import ScrollToTop from "react-scroll-to-top";

const ScrollToTopButton = () => {
  const theme = useTheme();
  return (
    <ScrollToTop
      smooth
      style={{
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.text.main}`,
        borderRadius: "10px",
        boxShadow: "none",
        bottom: "35px",
        right: "30px",
      }}
      component={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <KeyboardArrowUpRoundedIcon
            sx={{ color: theme.palette.text.main, fontSize: "28px" }}
          />
        </Box>
      }
    />
  );
};

export default ScrollToTopButton;
